const rowTypeAttr = 'k-parent-node';
const colgroupAttr = 'k-colgroup-data';
const resizableAttr = 'k-resizable-node';
const resizableWrap = 'k-editor-resize-wrap-element';
const resizeHandle = 'k-editor-resize-handle';
const dataResizeDirTable = 'data-dir-table-resize';
const dataResizeDirImage = 'data-dir-image-resize';

export { colgroupAttr, dataResizeDirImage, dataResizeDirTable, resizableAttr, resizableWrap, resizeHandle, rowTypeAttr };
